import loadable from '@loadable/component';
import React from 'react';
import { ListingProductLoader } from 'components/ListingLoader';


export default loadable(
  () => import(/* webpackChunkName: "OfferList" */ './Loadable'),
  {
  fallback: <ListingProductLoader length={5} />,
  }
  );
